import React, { useEffect, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import ButtonTooltip from '../../Inputs/ButtonTooltip';
import { FaPencil } from 'react-icons/fa6';
import { api } from '../../api/api';
import { Alert, AlertErro } from '../../../util/Alertas';
import { GetDataUser } from "../../../util/GetDataUser";
import { eTipoUsuario } from '../../../enum/eTipoUsuario';

function ModalEditarPedido({ PedidoId, Produtos, Historico, Pedido, reloadPage, usuarios = [], }) {
    const usuario = GetDataUser();
    const [show, setShow] = useState(false);
    const [produtosAdicionados, setProdutosAdicionados] = useState([]);
    const [produtoSelecionado, setProdutoSelecionado] = useState({ valor: 0 });
    const [quantidade, setQuantidade] = useState(1);
    const [descontoPercentual, setDescontoPercentual] = useState(0);
    const [observacao, setObservacao] = useState('');
    const [prazoPgt, setPrazoPgt] = useState('');
    const [formaPgt, setFormaPgt] = useState('Dinheiro');
    const [pedidoEmiteNf, setPedidoEmiteNf] = useState('Sim');
    const [dataVencimentoPgt, setDataVencimentoPgt] = useState('');
    const [dataEstimadaEntrega, setDataEstimadaEntrega] = useState('');
    const [vendedorSelecionado, setVendedorSelecionado] = useState('');

    const TransferirQtdHtProdutos = (produtos, historico) => {
        const produtosAtualizados = produtos.map(produto => ({ ...produto }));
        const produtosEncontrados = [];

        for (const itemHistorico of historico) {
            const produto = produtosAtualizados.find(prod => prod.id === itemHistorico.produto_id);
            if (produto) {
                if (!produto.qtdProdutos) produto.qtdProdutos = 0;
                produto.qtdProdutos += itemHistorico.quantidade;
                produto.valorDesconto = itemHistorico.desconto_unitario;
                produtosEncontrados.push(produto);
            }
        }

        return produtosEncontrados;
    }

    const BuscarHistoricoPedido = () => {
        setDescontoPercentual(Pedido.percentual_desconto);
        setObservacao(Pedido.observacao);
        var hitProd = TransferirQtdHtProdutos(Produtos, Historico);
        setProdutosAdicionados(hitProd);
        setPrazoPgt(Pedido.prazo_pagamento);
        setFormaPgt(Pedido.forma_pagamento);
        setPedidoEmiteNf(Pedido.emite_nota_fiscal ? "Sim" : "Não");
        const dtEstimada = Pedido.data_estimada_entrega ? Pedido.data_estimada_entrega.split("T")[0] : '';
        setDataEstimadaEntrega(dtEstimada)
        const dias = parseInt(Pedido.prazo_pagamento, 10);
        if (!isNaN(dias)) {
            const novaData = !dtEstimada ? new Date(Pedido.data_pedido) : new Date(`${dtEstimada}T00:00:00`);
            novaData.setDate(novaData.getDate() + dias);
            setDataVencimentoPgt(novaData.toISOString().split('T')[0]);
        }
        setVendedorSelecionado(Pedido.vendedorusuarioid)
    }

    useEffect(() => {
        BuscarHistoricoPedido();
    }, []);

    const getValue = () => produtoSelecionado && (quantidade * produtoSelecionado.valor).toFixed(2);

    const onChangeProdutoSelecionado = (e) => {
        const produtoId = parseInt(e.target.value);
        const produtoSelecionado = Produtos.find(
            (p) => p.id === produtoId
        );
        setProdutoSelecionado(produtoSelecionado);
    }

    const removerProduto = (produtoRemovido) => {
        const novosProdutosAdicionados = produtosAdicionados.filter(
            (produto) => produto.id !== produtoRemovido.id
        );
        setProdutosAdicionados(novosProdutosAdicionados);
    }

    const onChangeValor = (produtoId, quantidade, e) => {
        try {
            const valor = e.target.value.replace(/[^0-9,.]/g, '').replace(',', '.');
            if (valor.includes('.') && (valor.split('.').length === 1 || valor.split('.').length > 1 && valor.split('.')[1] === '')) {
                const produtoSemValidacao = produtosAdicionados.map((produto) => {
                    if (produto.id === produtoId) {
                        return { ...produto, valorDesconto: valor };
                    }
                    return produto;
                });
                setProdutosAdicionados(produtoSemValidacao);
                return;
            }

            const valorDescontoReais = valor === '' ? 0 : parseFloat(valor);

            if (CalcularValorDescontoPorQuantidade(produtoId, quantidade, valorDescontoReais)) {
                return;
            }

            if (!isNaN(valorDescontoReais)) {
                const updatedProdutosAdicionados = produtosAdicionados.map((produto) => {
                    if (produto.id === produtoId) {
                        return { ...produto, valorDesconto: valorDescontoReais };
                    }
                    return produto;
                });
                setProdutosAdicionados(updatedProdutosAdicionados);
            } else {
                Alert('Valor digitado esta incorreto!', false, true);
            }
        } catch (error) {
            Alert('Valor digitado esta incorreto!', false, true);
        }
    };

    const onAddProduto = () => {
        if (produtoSelecionado) {
            const produtoExistente = produtosAdicionados.find(
                (p) => p.id === produtoSelecionado.id
            );
            const novaQuantidade = parseInt(quantidade);

            if (produtoExistente) {
                const updatedProdutosAdicionados = produtosAdicionados.map((p) =>
                    p.id === produtoExistente.id
                        ? { ...p, qtdProdutos: p.qtdProdutos + novaQuantidade }
                        : p
                );
                setProdutosAdicionados(updatedProdutosAdicionados);
            } else {
                setProdutosAdicionados([
                    ...produtosAdicionados,
                    { ...produtoSelecionado, qtdProdutos: novaQuantidade },
                ]);
            }
            setProdutoSelecionado(null);
            const e = document.getElementById('produtos');
            e.value = "";
            setQuantidade(1);
        }
    }

    const calcularValorTotalPedido = () => {
        let total = produtosAdicionados.reduce((acc, produto) => {
            const totalProdutoSemDesconto = produto.valor * produto.qtdProdutos;
            // Aqui é aplicado o desconto em reais para cada produto
            const totalProdutoComDesconto =
                totalProdutoSemDesconto - (produto.valorDesconto || 0);
            return acc + totalProdutoComDesconto;
        }, 0);

        // Aqui é aplicado o desconto percentual ao total do pedido
        const descontoPercentualValor = (total * descontoPercentual) / 100;
        total -= descontoPercentualValor;

        // Retorna o valor total formatado com duas casas decimais
        return total.toFixed(2);
    };

    const handleDescontoPercentualChange = (event) => {
        const inputValue = event.target.value;
        if (/^\d*\.?\d*$/.test(inputValue) || inputValue === "") {
            const percentual = inputValue === "" ? "" : parseFloat(inputValue);
            if (percentual >= 0 && percentual <= 100) {
                setDescontoPercentual(percentual);
            }
        }
    };

    const RecuperarValorMinimoProduto = (produto) => {
        if (usuario.IsMaster) {
            return produto.valorMinimoMaster > 0
                ? produto.valorMinimoMaster
                : produto.valorMinimo
        }

        return produto.valorMinimo
    }

    const CalcularValorDescontoPorQuantidade = (produtoId, quantidade, valorDescontoDigitado) => {
        let produto = Produtos.filter(x => x.id === produtoId)[0];

        let valorTotal = produto.valor * quantidade;
        let valorMinimo = RecuperarValorMinimoProduto(produto) * quantidade;
        let valorMaximoDesconto = (valorTotal - valorMinimo);

        if (valorMaximoDesconto < valorDescontoDigitado) {
            Alert(`Valor do pedido está a baixo que o valor minímo.
                Desconto permitido até o valor de R$ ${valorMaximoDesconto}`, false, true);
            return true;
        }

        return false;
    }

    const CalcularValorMinimo = (desconto) => {
        if (/^\d*\.?\d*$/.test(desconto) || desconto === "") {
            const percentual = desconto === "" ? "" : parseFloat(desconto);
            if (percentual >= 0 && percentual <= 100) {
                let total = produtosAdicionados.reduce((acc, produto) => {
                    acc += RecuperarValorMinimoProduto(produto) * produto.qtdProdutos;
                    return acc;
                }, 0);

                let valorVenda = produtosAdicionados.reduce((acc, produto) => {
                    const totalProdutoSemDesconto = produto.valor * produto.qtdProdutos;
                    const totalProdutoComDesconto =
                        totalProdutoSemDesconto - (produto.valorDesconto || 0);
                    return acc + totalProdutoComDesconto;
                }, 0);

                let valorDesconto = (valorVenda * percentual) / 100;
                let abaixo = (valorVenda - valorDesconto.toFixed(2)) < total;

                if (abaixo) {
                    Alert(`Valor do pedido está a baixo que o valor minímo.
          Desconto permitido até o valor de R$ ${total}`, false, true);
                }

                return abaixo;
            }
        }
    }

    const calcularValorTotalSemDescontoPedido = () => {
        let total = produtosAdicionados.reduce((acc, produto) => {
            const totalProdutoSemDesconto = produto.valor * produto.qtdProdutos;
            // Aqui é aplicado o desconto em reais para cada produto
            return acc + totalProdutoSemDesconto;
        }, 0);

        return total.toFixed(2);
    };

    const onSubmit = () => {
        if (produtosAdicionados.length === 0) {
            Alert("Por favor, selecione pelo menos um produto.", false, true);
            return;
        }

        if (!dataEstimadaEntrega) {
            Alert("Por favor, informe a data estimada para entrega.", false, true);
            return;
        }

        if (CalcularValorMinimo(descontoPercentual)) {
            return;
        }

        const vt = calcularValorTotalPedido();
        const vs = calcularValorTotalSemDescontoPedido();
        const data = new FormData();

        produtosAdicionados.forEach(produto => { produto.quantidade = produto.qtdProdutos });

        const obj = JSON.stringify({
            PedidoId: PedidoId,
            ClienteId: Pedido.cliente_id,
            ProdutosAdicionado: produtosAdicionados,
            ValorTotal: vt,
            ValorDesconto: vs - vt,
            PercentualDesconto: descontoPercentual ?? 0,
            Observacao: observacao,
            prazoPgt,
            formaPgt,
            pedidoEmiteNf: pedidoEmiteNf === 'Sim',
            dataEstimadaEntrega: dataEstimadaEntrega,
            vendedorUsuarioId: vendedorSelecionado
        });
        data.append("obj", obj);
        try {
            api.post("api/Pedido/EditarPedido", data, res => {
                Alert("Pedido editado com sucesso!");
                reloadPage();
                setShow(false);
            }, erro => AlertErro(erro))

        } catch (error) {
            console.error("Erro ao enviar pedido:", error);
        }
    }

    const onChageDias = ({ target }) => {
        const { value } = target;
        const dias = parseInt(value, 10);

        if (!isNaN(dias)) {
            const novaData = !dataEstimadaEntrega ? new Date() : new Date(`${dataEstimadaEntrega}T00:00:00`);
            novaData.setDate(novaData.getDate() + dias);
            setDataVencimentoPgt(novaData.toISOString().split('T')[0]);

            const dataEstimadaNova = novaData;
            dataEstimadaNova.setDate(novaData.getDate() - dias);
            setDataEstimadaEntrega(dataEstimadaNova.toISOString().split('T')[0]);
        }
        setPrazoPgt(value);
    }

    const onChangeVencimento = ({ target }) => {
        const { value } = target;

        const hoje = new Date
        hoje.setHours(0, 0, 0, 0);

        const dataSelecionada = new Date(`${value}T00:00:00`);
        dataSelecionada.setHours(0, 0, 0, 0);

        if (dataSelecionada < hoje) {
            Alert("A data de vencimento não pode ser menor que hoje.", true, true);
            target.value = "";
            return;
        }

        const diffEmMilissegundos = dataSelecionada - hoje;
        const diffEmDias = Math.ceil(diffEmMilissegundos / (1000 * 60 * 60 * 24));
        setPrazoPgt(diffEmDias);
        setDataVencimentoPgt(value);
    };

    const onChangeVencimentoByData = ({ target }) => {
        const { value } = target;

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        const dataSelecionada = new Date(`${value}T00:00:00`);
        dataSelecionada.setHours(0, 0, 0, 0);

        if (dataSelecionada < hoje) {
            Alert("A data estimada de entrega não pode ser menor que hoje.", true, true);
            target.value = "";
            return;
        }

        const dataVencimento = new Date(dataSelecionada);
        dataVencimento.setDate(dataVencimento.getDate() + Number(prazoPgt));
        const vencimentoFormatado = dataVencimento.toISOString().split("T")[0];
        setDataVencimentoPgt(vencimentoFormatado);
    };

    const onChangeQuantidade = (produtoId, novaQuantidade) => {
        const novaLista = produtosAdicionados.map((produto) => {
            if (produto.id === produtoId) {
                return { ...produto, qtdProdutos: novaQuantidade };
            }
            return produto;
        });
        setProdutosAdicionados(novaLista);
    }

    // Vendedor não pode editar pedido (o backend também bloqueia)
    if (usuario.TipoUsuario === eTipoUsuario.Vendedor)
        return null;

    return (
        <>
            <ButtonTooltip text="Editar Pedido" textButton={<FaPencil size={20} color='#fff' />} className='btn btn-success' top={true} onClick={() => setShow(true)} />
            <Modal size='xl' show={show}>
                <Modal.Header>
                    <h2>Editar Pedido</h2>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        {usuario.IsMaster && <Row>
                            <Col md={6}>
                                <label>Vendedor</label>
                                <select
                                    id="produtos"
                                    className="form-control"
                                    value={vendedorSelecionado}
                                    onChange={e => setVendedorSelecionado(e.target.value)}
                                >
                                    <option value={usuario.UsuarioId}>Usuário Atual</option>
                                    {usuarios.map((usuario) => (
                                        <option
                                            key={usuario.usuarioId}
                                            value={usuario.usuarioId}
                                        >
                                            {usuario.nome}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                        </Row>}
                        <Row>
                            <Col md={6}>
                                <label>Produto</label>
                                <select
                                    id='produtos'
                                    className="form-control"
                                    onChange={onChangeProdutoSelecionado}
                                >
                                    <option value="">Selecione um Produto</option>
                                    {Produtos.map((produto) => (
                                        <option
                                            key={produto.id}
                                            value={produto.id}
                                        >
                                            {produto.nome}
                                        </option>
                                    ))}
                                </select>
                            </Col>
                            <Col md={6}>
                                <label>Quantidade</label>
                                <input
                                    className='form-control'
                                    type="number"
                                    min="1"
                                    value={quantidade}
                                    onChange={e => setQuantidade(e.target.value)}
                                    contentLabel="Quantidade"
                                />
                            </Col>
                            <Col md={10}>
                                <label htmlFor="">Total</label>
                                <input
                                    className='form-control'
                                    disabled
                                    type="text"
                                    value={`R$ ${getValue() ? getValue() : 0}`}
                                />
                            </Col>
                            <Col md={2}>
                                <label htmlFor=""></label>
                                <button
                                    style={{ marginTop: '2rem', width: '100%' }}
                                    className="btn btn-success"
                                    onClick={onAddProduto}
                                ><FaPlus /></button>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col md={12}>
                                <table className='table table-striped'>
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Quantidade</th>
                                            <th>Valor Desconto</th>
                                            <th>Valor Total</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {produtosAdicionados.map((produto, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td data-label="Nome">{produto.nome}</td>
                                                    <td data-label="Quantidade">
                                                        <input
                                                            type="number"
                                                            style={{ width: '50%' }}
                                                            value={produto.qtdProdutos}
                                                            min={1}
                                                            onChange={(e) => onChangeQuantidade(produto.id, e.target.value)}
                                                        />
                                                    </td>
                                                    <td data-label="Valor Desconto">
                                                        <input
                                                            type="number"
                                                            style={{ width: '50%' }}
                                                            value={produto.valorDesconto === 0 ? '' : produto.valorDesconto}
                                                            onChange={(e) => onChangeValor(produto.id, produto.qtdProdutos, e)}
                                                            step="0.01" // Permite inserir valores decimais
                                                        />
                                                    </td>
                                                    <td data-label="Valor Total">
                                                        R${" "}
                                                        {(
                                                            produto.valor * produto.qtdProdutos -
                                                            (produto.valorDesconto || 0)
                                                        ).toFixed(2)}
                                                    </td>
                                                    <td>
                                                        <button
                                                            onClick={() => removerProduto(produto)}
                                                            className='btn btn-danger'
                                                        >
                                                            -
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                        <Row>
                            {produtosAdicionados.length > 0
                                && <Col md={12}>
                                    <label>Desconto em %:</label>
                                    <input
                                        className='form-control'
                                        type="text"
                                        value={descontoPercentual}
                                        onChange={e => { handleDescontoPercentualChange(e); CalcularValorMinimo(e.target.value) }}
                                        pattern="\d*\.?\d*"
                                        title="Insira um número decimal válido"
                                    />
                                </Col>}
                            {produtosAdicionados.length > 0
                                && <Col md={12} style={{ width: '100%', textAlign: 'end', marginTop: 10 }}>
                                    <label style={{ fontSize: 25 }}>Total: R$ {calcularValorTotalPedido()}</label>
                                </Col>}
                        </Row>
                        <Row>
                            {produtosAdicionados.length > 0
                                && <Col md={6}>
                                    <label>Prazo para pagamento(Em Dias)</label>
                                    <input value={prazoPgt} onChange={onChageDias} min={1} max={365} className='form-control' placeholder='Em Dias' type="number" name="" id="" />
                                </Col>}
                            {produtosAdicionados.length > 0
                                && <Col md={6}>
                                    <label>Prazo para pagamento(Vencimento)</label>
                                    <input value={dataVencimentoPgt} onChange={onChangeVencimento} className='form-control' type="date" name="" id="" />
                                </Col>}
                            <br />
                            <br />
                            {produtosAdicionados.length > 0
                                && <Col md={6}>
                                    <label>Forma de pagamento</label>
                                    <select value={formaPgt} onChange={e => setFormaPgt(e.target.value)} className='form-control' name="" id="">
                                        <option value="Dinheiro">Dinheiro</option>
                                        <option value="Cartão">Cartão</option>
                                        <option value="Pix">Pix</option>
                                        <option value="Boleto">Boleto</option>
                                    </select>
                                </Col>}
                            {produtosAdicionados.length > 0
                                && <Col md={6}>
                                    <label>Pedido emite nota fiscal?</label>
                                    <select value={pedidoEmiteNf} onChange={e => setPedidoEmiteNf(e.target.value)} className='form-control' name="" id="">
                                        <option value="Sim">Sim</option>
                                        <option value="Não">Não</option>
                                    </select>
                                </Col>}
                            {produtosAdicionados.length > 0
                                && <Col md={6}>
                                    <label>Data Estimada Entrega</label>
                                    <input value={dataEstimadaEntrega} onChange={e => { setDataEstimadaEntrega(e.target.value); onChangeVencimentoByData(e) }} type="date" className='form-control' />
                                </Col>}
                        </Row>
                        <br />
                        <br />
                        <Row>
                            <Col md={12}>
                                <label>Observação:</label>
                                <textarea
                                    className="form-control"
                                    value={observacao}
                                    onChange={(e) => setObservacao(e.target.value)}
                                    placeholder="Digite alguma observação sobre o pedido aqui."
                                ></textarea>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-danger' onClick={() => { BuscarHistoricoPedido(); setShow(false) }}>Cancelar</button>
                    {produtosAdicionados.length > 0 && <button className='btn btn-primary' type='button' onClick={() => onSubmit()}>Atualizar Pedido</button>}
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ModalEditarPedido;